import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { TableProps } from "../../../Common/UI/Index";
import { IRootState } from "../../../../reducer/CombineReducer";
import { BandingListView } from "./BandingList.View";
import {
  PopulateBandListTable,
  PopulateGenderListTable,
  PopulateEthinicityListTable
} from "./Helper";
import { BandsTypes } from "./Types";
import "./Style.scss";

interface BandingProps {
  /**
   * Type of Band
   */
  bandType: BandsTypes;
}

/**
 * Responsible for rendering the list of banding
 */
export const BandingList: React.FC<BandingProps> = (props: BandingProps) => {
  const { bandType } = props;
  const dispatch = useDispatch();
  const outputConfig = useSelector((state: IRootState) => state.outputConfig);
  const bandingList = outputConfig.bandingList;

  /**
   * To get the banding data source
   * @returns the table data
   */
  const getDataSourceForBanding = (): TableProps => {
    let dataSource = {} as TableProps;
    switch (bandType) {
      case BandsTypes.AGE:
        dataSource = PopulateBandListTable(JSON.stringify(bandingList), dispatch);
        break;
      case BandsTypes.GENDER:
        dataSource = PopulateGenderListTable(JSON.stringify(bandingList), dispatch);
        break;
      case BandsTypes.ETHNICITY:
        dataSource = PopulateEthinicityListTable(JSON.stringify(bandingList), dispatch);
        break;
    }

    return dataSource;
  };

  return (
    <BandingListView
      band={bandType}
      data={getDataSourceForBanding()}
    />
  );
};
